export const NAV_URLS = {
    REVIEW_PAGE: 'review',
    FORM_PAGE: 'form',
    LOGOUT_PAGE: 'logout',
    LOGIN_PAGE: 'login',
    DEBUG_PAGE: 'debug',
    LOGIN_UNAUTHORISED: 'login-unauthorised'
}